/**
 * 이미지 URL 유틸 — CDN/로컬 정적 자산을 <img src> 에 안전하게 넣기 위한 헬퍼.
 *
 * 배경
 *   S3 키와 로컬 썸네일 경로에 한글이 포함될 수 있는데(예: 프로젝트명·포스터명),
 *   브라우저는 raw 멀티바이트가 들어있는 URL 을 그대로 따라가지 못해 이미지가 깨진다.
 *   path 부분만 percent-encode 해서 안전한 URL 로 만든다.
 */

/**
 * 절대 CDN URL 이거나 로컬 정적 경로를 받아서 <img src> 에 안전한 URL 로 정규화한다.
 *
 * <p>중요 — AWS S3 Presigned URL 처리</p>
 *   Presigned URL 의 X-Amz-Credential 같은 쿼리 값에는 이미 percent-encoded `%2F` 가 들어있다.
 *   여기에 encodeURI 를 추가로 적용하면 `%` 자체가 `%25` 로 다시 인코딩되어 `%252F` 가 되고,
 *   서명 검증이 실패해 S3 가 400 으로 응답한다.
 *   따라서 X-Amz-Signature 가 포함된 URL 은 AWS SDK 가 인코딩을 마친 상태로 간주하고 그대로 반환.
 */
export function safeImgUrl(rawUrl) {
    if (!rawUrl) return "";
    // Presigned URL (AWS SDK 가 이미 정확히 인코딩한 상태) 은 손대지 않는다.
    if (rawUrl.indexOf("X-Amz-Signature=") >= 0) {
        return rawUrl;
    }
    try {
        return encodeURI(decodeURI(rawUrl));
    } catch {
        // decodeURI 가 잘못된 시퀀스로 실패하면 raw 에 그냥 encodeURI 적용.
        return encodeURI(rawUrl);
    }
}

/**
 * 로컬 썸네일 또는 CDN URL 중 어느 쪽이든 받아서 <img src> 에 쓸 수 있는
 * 절대 URL 로 정리한다. thumbnailFilePath 가 있으면 우선, 없으면 filePath fallback.
 *
 * @param {{thumbnailFilePath?: string, filePath?: string}} item
 * @param {string} apiRealBase  REACT_APP_API_REAL_URL (로컬 썸네일이 서빙되는 origin)
 */
export function pickThumbnailSrc(item, apiRealBase) {
    if (!item) return "";
    const thumb = item.thumbnailFilePath;
    if (thumb) {
        const joined = `${apiRealBase}/${thumb}`.replaceAll("//", "/").replace(":/", "://");
        return safeImgUrl(joined);
    }
    return safeImgUrl(item.filePath || "");
}
